import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formValueSelector } from 'redux-form';
import { push } from 'react-router-redux';
import Form from '../../components/forms/OvmForm';
import { saveOvm, deleteOvm, withRedirect } from '../../CroActions';
import { isLegitimate, isOfficialAdmin, isInternal } from '../../CroUtils';
import { breadcrumbs } from '../../../../actions/appActions';

const selector = formValueSelector('ovmForm');

const mapStateToProps = (state, { params, auth }) => ({
  breadcrumbsItems: [{ label: 'Podpůrné orgány' }, { label: 'Editace podpůrného orgánu' }],
  loginData: { ic: selector(state, 'ic') },
  allowDatabox: selector(state, 'allowDatabox'),
  allowBasic: selector(state, 'allowBasic'),
  url: `${auth.startUrl}/api/podpurne-organy/${params.id}`,
  disabled: isLegitimate(auth),
  canDelete: isOfficialAdmin(auth),
});

const onSubmit = (url) => withRedirect(saveOvm(url), `${url}/podpurne-organy`);

const mapDispatchToProps = (dispatch, props) => {
  const redirectUrl = props.auth.startUrl + '/podpurne-organy';
  const onDeleteRedirect = withRedirect(deleteOvm, redirectUrl);

  return {
    ...bindActionCreators({ onSubmit: onSubmit(props.auth.startUrl), breadcrumbs }, dispatch),
    onDelete: (note) => dispatch(onDeleteRedirect(props.params.id, note)),
    onShowHistory: (props.params.id && isInternal(props.auth))
      ? () => dispatch(push(`${props.auth.startUrl}/podpurne-organy/${props.params.id}/historie`))
      : null,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
